const parseImageMap = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    return JSON.parse(value) || {}
  } catch {
    return {}
  }
}

export const avatarImage = (user, variant = 'thumbnail') => {
  if (!user) return ''

  const variants = parseImageMap(user.avatar_variants)
  return variants[variant]
    || variants.profile
    || variants.thumbnail
    || user.avatar
    || ''
}

export const bannerImage = (banner, device = 'mobile') => {
  if (!banner) return ''

  const variants = parseImageMap(banner.image_variants)
  const originals = parseImageMap(banner.images)
  return variants[device] || originals[device] || ''
}
